import { Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Impact from "./pages/impact/Impact";
import Goal from "./pages/goal/Goal";
import DonateCause from "./pages/donateCause/DonateCause";
import Payment from "./pages/payment/Payment";
import Footer from "./components/footer/Footer";
import Contribute from "./pages/contribute/Contribute";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/goal" element={<Goal />} />
        <Route path="/donateCause" element={<DonateCause />} />
        <Route path="/contribute" element={<Contribute />} />
        <Route path="/payment" element={<Payment />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
